export class ListType {
    id:number;
    value: string;
}
